import { useAxios } from '../../../hooks/useAxios/useAxios';
import { useAuthModalStore } from '../../../store/auth-modal';
import { Countdown } from './Countdown';
import { ErrorMessage } from './ErrorMessage';
import { useEffect, useState } from 'react';

export function ModalContent({
  title,
  description,
  children,
  showFooter = true,
  message,
  onClickEvent,
  htmlContent
}) {
  const {
    changeHandler,
    openModal,
    closeModal,
    setActions,
    setDdToken,
    setErrorMessage,
    setCurrentMethod,
    ...state
  } = useAuthModalStore();

  const [isAlreadySent, setIsAlreadySent] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState();

  const { execute: resendCodePhone } = useAxios(
    '/public/buyontrust/auth/send_sms',
    {
      method: 'post',
      data: {
        phone: state?.phone
      }
    },
    false,
    data => {
      data?.token && setDdToken(data.token);
      setErrorMessage(data);
    }
  );

  const { execute: resendCodeEmail } = useAxios(
    '/public/buyontrust/auth/send_code_to_email',
    {
      method: 'post',
      data: {
        email: state?.formData.email,
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (!data?.success) {
        setErrorMessage(data);
      }
    }
  );

  const chooseMethod = () => {
    if (!state.isUserRegistered) {
      if (state.email) {
        resendCodeEmail();
      } else {
        resendCodePhone();
      }
    } else {
      setActions('showSmsReceivingMethodPanel');
    }
  };

  const changeMode = () => {
    changeHandler({
      email: '',
      phone: ''
    });
    setCurrentMethod(state.actions.phoneMode ? 'email' : 'phone');
    setActions(
      state.actions.phoneMode
        ? 'emailModal'
        : !state.isUserRegistered
        ? 'phoneModeSignUp'
        : 'phoneMode'
    );
  };

  useEffect(() => {
    setIsAlreadySent(message?.includes('already been sent'));

    if (isAlreadySent) {
      const numberOfSeconds = message?.match(/\d+/);
      numberOfSeconds && setSecondsLeft(parseInt(numberOfSeconds[0], 10));
    }
  }, [message, isAlreadySent]);

  useEffect(() => {
    setErrorMessage('');
  }, []);

  return (
    <div className="modal-wrapper">
      <div className="container">
        <span className="text-secondary d-block text-center mb-2">{title}</span>
        {/*<hr className="mt-1 mb-3" />*/}
        {message &&
          (isAlreadySent ? (
            <ErrorMessage
              message={
                <>
                  <span>
                    Verification code has already been sent. Please wait&nbsp;
                  </span>
                  {secondsLeft && (
                    <Countdown
                      start={secondsLeft}
                      onEnd={() => setErrorMessage('')}
                    />
                  )}
                  <span>&nbsp;seconds before trying again</span>
                </>
              }
              status={state.status}>
              <span
                onClick={onClickEvent}
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            </ErrorMessage>
          ) : (
            <ErrorMessage message={message} status={state.status}>
              <span
                onClick={onClickEvent}
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            </ErrorMessage>
          ))}

        {description ? (
          <div className="form-wide">
            <span>{description}</span>
          </div>
        ) : (
          ''
        )}
        {children}

        {showFooter && (
          <div className="text-center mt-3">
            {state?.actions.showVerificationCodePanel ? (
              <span>
                Didn't get a code?{' '}
                <a
                  style={{
                    fontWeight: '600',
                    color: '#00aee4',
                    cursor: 'pointer'
                  }}
                  onClick={() => chooseMethod()}>
                  Resend Code
                </a>
              </span>
            ) : state.actions.phoneMode ? (
              <span className="text-secondary line-height-3 font-weight-bold">
                Don't have a phone?{' '}
                <a
                  style={{
                    cursor: 'pointer',
                    color: '#00aee4',
                    fontWeight: '700'
                  }}
                  onClick={event => changeMode(event)}>
                  Use email
                </a>
              </span>
            ) : state.actions.emailModal ? (
              <span className="text-secondary line-height-3 font-weight-bold">
                Want to use your{' '}
                <a
                  style={{
                    color: '#00aee4',
                    cursor: 'pointer',
                    fontWeight: '700'
                  }}
                  onClick={event => changeMode(event)}>
                  phone
                </a>
                ?
              </span>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    </div>
  );
}
